import alan from './Alan.png'
import editor from './editor.png'
import memories from './Memories.png'
import json_visualizer from './JSON_viewer.png'
import pr_direct from './PR_diff.png'
import logic_builder from './Logic_builder.png'
import omnifood from './Omnifood.png'
import FRONTENDICONS from '../Frontend'
import BACKENDICONS from '../Backend'
import DATABASEICONS from '../Databases'
import OTHERSICONS from '../Others'

const {
    cssIcon, jsIcon, reactIcon, reduxIcon, tailwindicon, viteIcon, webpackIcon
} = FRONTENDICONS;

const { node } = BACKENDICONS;

const { mongodb } = DATABASEICONS;
const { jest, github} = OTHERSICONS;



const PROJECTS = [
  {
    header: "PR Buddy",
    footer: "AI powered PR assistant for GitHub repositories",
    logo: pr_direct,
    link: "https://pr-bud-1.vercel.app",
    techstack: [ reactIcon, tailwindicon, viteIcon,cssIcon,jsIcon,github,jest],
  },
 
  {
    header: "Visual Logic Builder",
    logo: logic_builder,
    footer: "Serverless Collaborative Visual Logic Builder",
    techstack: [ reactIcon, viteIcon,cssIcon,jsIcon],
    link: "https://frontend-blocks-zeta.vercel.app",
  },
  {
    header: "JSON visualizer",
    logo: json_visualizer,
    footer: "JSON visualization tool",
    techstack: [reactIcon, viteIcon,cssIcon,jsIcon],
    link: "https://json-viewer-gold.vercel.app",
  },
 
  {
    header: "Omnifood",
    logo: omnifood,
    footer: "HTML and CSS, Yupp thats it 🤓",
    techstack: [reactIcon, reduxIcon],
    link: "https://pratikbee.github.io/Omnifood/",
  },
  {
    header: "Memories",
    logo: memories,
    footer: "Share thoughts, pictures for future memory lane 🤝",
    techstack: [reactIcon, cssIcon, jsIcon, reduxIcon, node, mongodb],
    link: "https://memories-pratikbee.netlify.app/",
  },
  {
    header: "Alan News",
    logo: alan,
    footer: "Your daily news powered by Alan AI,",
    techstack: [reactIcon, cssIcon, jsIcon, reduxIcon, node, mongodb, webpackIcon],
    link: "https://github.com/pratikbee/artificial",
  },
  {
    header: "Code editor",
    logo: editor,
    footer: "Online Code editor supporting C++, C, JS and Python.",
    techstack: [reactIcon, cssIcon, jsIcon, reduxIcon, node, mongodb, webpackIcon],
    link: "https://github.com/pratikbee/Code_Editor",
  },
];

export default PROJECTS